import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import swal from 'sweetalert2';
import { HttpService } from 'app/core/http/http.service';
import { NotificationService } from 'app/shared/utils/notification.service';
import { BsModalRef } from 'ngx-bootstrap';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
@Component({
  selector: 'app-transaction-details',
  templateUrl: './transaction-details.component.html',
  styleUrls: ['./transaction-details.component.css']
})
export class TransactionDetailsComponent implements OnInit {

  // userName:string="";
  // listeUser:any[]=[{
  //   nom:"YAO",
  //   prenom:"Kouassi",
  //   login:"yakou",
  //   contact:"09212109",
  //   statut:'COMMERCANT',
  //   createdAt:"10/10/2010"
  // }];
  // p:number=1
  @Input() transaction;
  spinnerLoading : boolean = false;
  onClose: Subject<boolean> = new Subject<boolean>();
  constructor(public httpService:HttpService,private notification:NotificationService,public modalRef:BsModalRef) { 

  }

  ngOnInit() {
    //this.onClose.next(false);
    console.log("transaction", this.transaction);
    
}

closeModal(){
  this.modalRef.hide()
}

}
